import(/* webpackMode: "eager" */ "/opt/build/repo/app/ClientLayout.tsx");
import(/* webpackMode: "eager" */ "/opt/build/repo/lib/registry.tsx");
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js")